import React, { Component } from "react";
import { translate } from "react-i18next";

import { CSSTransition, TransitionGroup } from "react-transition-group";

import Image from "../../components/bannerHome/bannerHome.component";
import Video from "../../components/video/video.component";
import About from "../../components/about/about.component";
import Inscription from "../../components/inscription/inscription.component";
import Sponsors from "../../components/sponsors/sponsors.component";
import Subscription from "../../components/subscription/subscription.component";

class Home extends Component {
  UNSAFE_componentWillUpdate() {
    const requestLang = window.location.pathname.split("/");
    const size = requestLang.length - 1;

    if (requestLang[size] === "") {
      let url = "/" + this.props.i18n.language;
      this.props.history.replace(url, true);
    }

    let lang = requestLang[1];

    if (lang !== this.props.i18n.language) {
      let url = "/" + this.props.i18n.language;
      this.props.history.replace(url, true);
    }
  }

  render() {
    let { t, i18n } = this.props;
    const width = window.innerWidth;

    const PageFade = (props) => (
      <CSSTransition
        {...props}
        classNames="fadeTranslate"
        timeout={1000}
        mountOnEnter={true}
        unmountOnExit={false}
      />
    );

    return (
      <TransitionGroup>
        <PageFade>
          <div id="start">
            {width <= 992 ? (
              <Image t={t} i18n={i18n} />
            ) : (
              <Video t={t} i18n={i18n} />
            )}
            <About t={t} i18n={i18n} />
            <Inscription t={t} i18n={i18n} />
            <Sponsors t={t} />
            <Subscription t={t} />
          </div>
        </PageFade>
      </TransitionGroup>
    );
  }
}

export default translate("translations")(Home);



// WEBPACK FOOTER //
// ./src/pages/home/home.page.js